import PropTypes from 'prop-types'

export default {
    name: PropTypes.string,
    url: PropTypes.string,
    selected_media: PropTypes.string,
    file: PropTypes.arrayOf(PropTypes.shape({})),
    file_size: PropTypes.number,
    md5: PropTypes.string,
    length: PropTypes.number,
    date_start: PropTypes.number,
    date_end: PropTypes.number,
}
